/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps, useHistory } from 'react-router-dom';
import server from '../../../_api/backend';
import * as toast from '../../../_store/slice/toast';

export function AdminByMember() {
  const [detailItems, setDetailItems] = useState<any[]>([]);
  const [items, setItems] = useState<any[]>([]);
  const [startDate, setStartDate] = useState<string>('');
  const [endDate, setEndDate] = useState<string>('');
  const [searchVisable, setSearchVisable] = useState(false);
  const dispatch = useDispatch();
  const history = useHistory();

  // 주소창 강제이동 또는 관리자 권한이 없는 사용자 → 메인페이지 이동
  useEffect(() => {
    if (
      window.localStorage.getItem('token') === null ||
      window.localStorage.getItem('authority') !== 'A'
    ) {
      dispatch(toast.error({ message: '관리자 권한이 없습니다.' }));
      history.push('/');
    }
  }, []);

  useEffect(() => {
    getStatistics();
  }, []);

  // 도서별 판매 통계 API 호출
  const getStatistics = async () => {
    await server
      .getMemberStatistics(startDate, endDate)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 특정 회원 구매내역 상세보기
  const onClickDetail = async (id: any) => {
    setSearchVisable(false);
    await server
      .getMemberStatisticsDetail(id)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setDetailItems(payload);
          setSearchVisable(true);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 데이터값 불러오기 (회원 목록)
  const ByMemberRow = items?.map((item: any, index: number) => (
    <ul className="row" onClick={() => onClickDetail(item.username)} key={Math.random()}>
      <li className="counter">{index + 1}</li>
      <li className="code">{item.username}</li>
      <li className="user">{item.name}</li>
      <li className="quantity">{Number(item.orderQty).toLocaleString()}</li>
      <li className="price">{Number(item.amount).toLocaleString()}</li>
      <li className="percentage">{Number(item.persentAge).toFixed(1)}</li>
    </ul>
  ));

  // 기간 검색
  function createTableHeader() {
    return (
      <div className="search">
        <div className="date">
          <label htmlFor="from">기간검색</label>
          <input
            type="text"
            id="from"
            name="from"
            placeholder="2021-01-01"
            onChange={(event) => {
              setStartDate(event.target.value);
            }}
          />
          <input
            type="text"
            id="to"
            name="to"
            placeholder="2021-02-01"
            onChange={(event) => {
              setEndDate(event.target.value);
            }}
          />
        </div>
        <button
          onClick={() => {
            getStatistics();
          }}
        >
          <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24">
            <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z" />
          </svg>
        </button>
      </div>
    );
  }

  // 분류 제목
  function createUserList() {
    return (
      <div className="table">
        <ul className="row title">
          <li className="counter">순위</li>
          <li className="code">아이디(ID)</li>
          <li className="user">이름</li>
          <li className="quantity">구매수량</li>
          <li className="price">구매금액</li>
          <li className="percentage">구매율</li>
        </ul>
        {ByMemberRow}
      </div>
    );
  }

  // 데이터값 불러오기 (회원 상세정보)
  const memberDetailRow = detailItems?.map((item: any) => (
    <a href="#" key={Math.random()}>
      <ul className="row">
        <li className="code">{item.b_code}</li>
        <li className="user">{item.p_name}</li>
        <li className="day">{new Date(item.pay_date).toLocaleDateString()}</li>
        <li className="user-name">{item.name}</li>
        <li className="price">{Number(item.p_price).toLocaleString()}</li>
      </ul>
    </a>
  ));

  // AdminByBook 리턴값
  return (
    <>
      <main className="list-books-statistics wrapper">
        <div className="title">
          <h1>회원별 판매 통계</h1>
        </div>
        <div className="content">
          <div className="table-header">{createTableHeader()}</div>
          {createUserList()}
        </div>
      </main>

      <div className={`modal modal-order-list ${searchVisable ? 'active' : ''}`}>
        <header>
          <div className="title">
            <h3>주문 상세조회</h3>
            <svg
              className="close"
              xmlns="http://www.w3.org/2000/svg"
              width="30"
              height="30"
              viewBox="0 0 18 18"
              onClick={() => {
                setSearchVisable(false);
              }}
            >
              <path d="M14.53 4.53l-1.06-1.06L9 7.94 4.53 3.47 3.47 4.53 7.94 9l-4.47 4.47 1.06 1.06L9 10.06l4.47 4.47 1.06-1.06L10.06 9z" />
            </svg>
          </div>
        </header>
        <div className="modal-content">
          <section className="list">
            <div className="table">
              <ul className="row title">
                <li className="order-id">주문번호</li>
                <li className="user">상품명</li>
                <li className="day">주문일</li>
                <li className="user-name">이름</li>
                <li className="price">주문결제금액</li>
              </ul>
              {memberDetailRow}
            </div>
          </section>
        </div>
      </div>
      <div className={`overlay ${searchVisable ? 'active' : ''}`} />
    </>
  );
}
